import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { BehaviorSubject, Observable, Subject } from "rxjs";
import { HttpclientService } from "../../../../../shared";
import { EmailUpdateUserEmailRequest } from "./EmailUpdateUserEmailRequest";
import { DefaultPagePreferenceRequest } from "./DefaultPagePreferenceRequest";
import { ChangePasswordRequest } from "./ChangePasswordRequest";

@Injectable()
export class DataService_MySettings {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	EmailProviderSelectList(UserID) {
		var postResult$ = new Subject();
		var url = "Dashboard/EmailProviderSelectList?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailSelectByUser(UserID) {
		var postResult$ = new Subject();
		var url = "Dashboard/EmailSelectByUser?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailUpdateUserEmail(parms: EmailUpdateUserEmailRequest) {
		var postResult$ = new Subject();
		var url = "Dashboard/EmailUpdateUserEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserSettingsSelect(UserID) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserSettingsSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserMFAUpdate(UserID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserMFAUpdate?UserID=" + UserID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserResetMFA(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserResetMFA?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DefaultPageInfoSelect(UserID) {
		var postResult$ = new Subject();
		var url = "Dashboard/DefaultPageInfoSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserUpdateDefaultPage(parms: DefaultPagePreferenceRequest) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserUpdateDefaultPage";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserResetDefaultPage(UserID) {
		var postResult$ = new Subject();
		var url = "Dashboard/UserResetDefaultPage?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CheckExistingPassword(parms: ChangePasswordRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/CheckExistingPassword";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ChangePassword(parms: ChangePasswordRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/ChangePassword";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	PortalAppUserSelect() {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppUserSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
